import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModelAttributeConfig } from '@zipari/shared-ds-util-configuration';

@Component({
  selector: 'side-panel-custom',
  templateUrl: './side-panel-custom.component.html',
  styleUrls: ['./side-panel-custom.component.scss'],
})
export class SidePanelCustomComponent {
  @Input() customLabel = 'Custom';
  @Input() attributeList: ModelAttributeConfig[] = [];
  @Input() attributeListContext: any;
  @Input() useCustom: boolean;
  @Output() customActionClicked: EventEmitter<any> = new EventEmitter();

  handleCustomAction(propContent: string) {
    this.customActionClicked.emit(propContent);
  }
}
